exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-top {\n  padding: 18px 13px 13px;\n  background-color: #ffffff; }\n\n.al-content {\n  background-color: #fff;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);\n  z-index: 0;\n  padding: 8px 32px 8px 40px; }\n\nh1.al-title {\n  font-weight: 700;\n  color: #374767;\n  float: left;\n  width: auto;\n  margin: 0;\n  padding: 0;\n  font-size: 24px;\n  text-transform: uppercase;\n  opacity: 0.9; }\n\n.al-breadcrumb {\n  background: none;\n  color: #374767;\n  padding: 0;\n  margin: 0;\n  float: right;\n  padding-top: 5px; }\n  .al-breadcrumb li {\n    font-size: 18px;\n    font-weight: 400; }\n    .al-breadcrumb li a {\n      color: #374767; }\n    .al-breadcrumb li.breadcrumb-item.active {\n      color: #374767; }\n\n.al-look {\n  float: right;\n  margin-right: 10px;\n  padding-top: 10px; }\n  .al-look > a {\n    font-size: 19px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/components/baContentTop/baContentTop.scss
// module id = 500
// module chunks = 52